<script setup lang="ts">
import DragIcon from '@/assets/icons/drag.svg?component'
import CostDataRow from '@/components/CampaignListItem/CostDataRow.vue'
import type { CampaignFormType } from '@/lib/types/campaign.types'
import { BoxComponent, FlexComponent, TypographyComponent } from '@/ui-library'

defineProps<{
  advertiserId: number | string
  advertiserName: string
  campaignName: string
  trafficSourceCosts: CampaignFormType['trafficSourceCosts']
  currency?: string
  isDraggable?: boolean
}>()
</script>
<template>
  <BoxComponent
    :pt="16"
    :pb="16"
    :pr="16"
    :pl="4"
    class="campaign-form-priority-item__container"
    :class="{ 'campaign-form-priority-item__container-draggable': isDraggable }"
  >
    <FlexComponent align="center">
      <BoxComponent :w="48" h="100%">
        <FlexComponent v-if="isDraggable" justify="center">
          <el-icon :size="24">
            <DragIcon />
          </el-icon>
        </FlexComponent>
      </BoxComponent>
      <BoxComponent :min-h="44">
        <BoxComponent :mb="4">
          <TypographyComponent variant="title-large" :class="{ 'campaign-form-priority-item__placeholder-name': !campaignName }">
            {{ campaignName || 'Internal name' }}
          </TypographyComponent>
        </BoxComponent>
        <CostDataRow v-if="trafficSourceCosts" :currency="currency ? currency : ''" :grouped-traffic-source-costs="trafficSourceCosts" />
      </BoxComponent>
    </FlexComponent>
  </BoxComponent>
</template>
<style lang="scss" scoped>
.campaign-form-priority-item__container {
  border-radius: 16px;
  border: 1px solid rgba(34, 34, 34, 0.04);
}
.campaign-form-priority-item__container-draggable {
  cursor: grab;
  background: rgba(34, 34, 34, 0.02);
}
.campaign-form-priority-item__drag-icon-container {
  flex-shrink: 0;
}
.campaign-form-priority-item__placeholder-name {
  color: var(--secondary-64);
  font-style: italic;
}
.campaign-form-priority-item__advertiser-logo {
  max-width: 64px;
  height: 32px;
  object-fit: contain;
}
</style>
